import React, { useState } from "react";
import { Waypoint } from "react-waypoint";

function MyTasks() {
  const [animateleft, setAnimateLeft] = useState("");
  const [animateUp, setAnimateUp] = useState("");
  const [animateRight, setAnimateRight] = useState("");
  const [animateDown, setAnimateDown] = useState("");

  const handleWaypointEnterLeft = () => {
    setAnimateLeft("visible animate__animated animate__fadeInLeft");
  };
  const handleWaypointEnterUp = () => {
    setAnimateUp("visible animate__animated animate__backInUp");
  };
  const handleWaypointEnterDown = () => {
    setAnimateDown("visible animate__animated animate__backInDown");
  };
  const handleWaypointEnterRight = () => {
    setAnimateRight("visible animate__animated animate__fadeInRight");
  };
  return (
    <section className="my-tasks" id="tasks">
      <div className="container">
        <div className="row">
          <Waypoint onEnter={handleWaypointEnterLeft}>
            <div className={`col-lg-3 hide ${animateleft}`}>
              <div className="task">
                <h5>Development</h5>
                <img
                  className="img-fluid"
                  src={require("../images/development.png")}
                  alt=""
                />
                <p>
                  As a front-end developer, I bring a blend of technical skills,
                  creativity, and passion for building user-friendly and
                  functional websites and web applications.
                </p>
              </div>
            </div>
          </Waypoint>

          <Waypoint onEnter={handleWaypointEnterDown}>
            <div className={`col-lg-3 hide ${animateDown}`}>
              <div className="task">
                <h5>Design</h5>
                <img
                  className="img-fluid"
                  src={require("../images/design.png")}
                  alt=""
                />
                <p>
                  With a passion for creating intuitive and visually appealing
                  websites, I strive to design innovative and user-friendly
                  experiences for my clients.
                </p>
              </div>
            </div>
          </Waypoint>

          <Waypoint onEnter={handleWaypointEnterUp}>
            <div className={`col-lg-3 hide ${animateUp}`}>
              <div className="task">
                <h5>UI/UX Developer</h5>
                <img
                  className="img-fluid"
                  src={require("../images/ui.png")}
                  alt=""
                />
                <p>
                  As a UI/UX Designer, I create intuitive and visually pleasing
                  user experiences by utilizing empathy, design thinking, and
                  user research to solve real problems and deliver meaningful
                  solutions.
                </p>
              </div>
            </div>
          </Waypoint>

          <Waypoint onEnter={handleWaypointEnterRight}>
            <div className={`col-lg-3 hide ${animateRight}`}>
              <div className="task">
                <h5>Analytics</h5>
                <img
                  className="img-fluid"
                  src={require("../images/analytics.png")}
                  alt=""
                />
                <p>
                  I have a strong understanding of analytics and data-driven
                  decision making, constantly seeking ways to optimize user
                  experiences and improve website performance.
                </p>
              </div>
            </div>
          </Waypoint>
        </div>
      </div>
    </section>
  );
}

export default MyTasks;
